<fieldset id="behavior_cta_fieldset" class="fieldset behavior-general"><legend>General</legend><dl>    <ul>
      <li>
        <label class="switch">
          <input type="checkbox" name="inheritable" {{#if inheritable }}checked{{/if}} >
          <div class="slider"></div>
          <span data-help="components-inheritable">Inheritable by child pages</span>
        </label>

        <span class="comment">
          This component will appear automatically on child pages. Use this to provide common content across a set
          of nested pages.
        </span>
      </li>

      <li>
        <label class="switch" for="cta">
          <input type="checkbox" id="cta" name="cta" {{#if cta }}checked{{/if}} >
          <div class="slider"></div>
          <span data-help="components-call_to_action">Call-to-Action</span>
        </label>

        <span class="comment">
          A <strong data-help="components-call_to_action">Call-To-Action (CTA)</strong> is a promoted component that prompts users to take action, typically via a form submission, phone number, or link.
        </span>
      </li>
      <li class="cta-options">
        <ul>
          <li>
            <h3 data-help="components-call_to_action-type">CTA Type</h3>
            {{sp_select_tag "" class="cta-category-select" choices=categoryItems selected=cta_category required=true includeBlank=false}}
          </li>
          <li>
            <h3 data-help='components-call_to_action-teaser_button_text'>CTA Teaser Button Text</h3>
            <input type='text' id='cta_teaser_button_text' name='cta_teaser_button_text' value='{{ cta_teaser_button_text }}'>

          </li>
        </ul>
        </li>
    </ul>
</dl></fieldset>

<div class="cta-options">
  <fieldset id="behavior_targeting_fieldset" class="fieldset behavior-targeting"><legend>Targeting</legend><dl>      <ul>
        <li>
          <sp-alert class="" type="success">                {{#if campaignTargeting }}
                  Users who reach this page through a campaign will be shown this CTA for the rest of their campaign session.
                {{ else }}
                  Users who reach this page from an external URL will be shown this CTA for the rest of their browsing session.
                {{/if}}
<span slot="prepend"><span class="icon-wrapper"><svg class="icon icon-target "><use xlink:href="/assets/admin/svg_icon_sprite-ed97dbd7.svg#icon-target-color" class="icon__use icon__use--color"></use></svg></span></span></sp-alert>
          </p>
        </li>
        <li>
          <label class="switch" for="targeting">
            <input type="checkbox" id="targeting" name="targeting" {{#if targeting }}checked{{/if}} >
            <div class="slider"></div>
            <span data-help="targeting">
              Use CTA for {{#if campaignTargeting }}Campaign{{ else }}Organic{{/if}} Targeting
            </span>
          </label>
          <span class="comment">If enabled, this CTA will follow a user throughout their browsing session.</span>
        </li>
        <li class="targeting-options">
          <h3 data-help="targeting-replacement_strategy">Replacement Strategy</h3>
          {{sp_select_tag "" class="replacement-strategy-select" choices=strategyItems selected=replacement_strategy required=true includeBlank=false}}
        </li>
{{#unless campaignTargeting}}
  <li>
    <label class="switch">
      <input type="checkbox" data-targeting-segment-condition="entry_page" {{#if targeting_segment.entry_page }}checked{{/if}} >
      <div class="slider"></div>
      <span data-help="targeting-restrictions-targeting-segment[entry-page]">Restrict to Entry Page</span>
    </label>
    <span class="comment">Only use this CTA for targeting if it's on the first page the visitor sees when entering the site</span>
  </li>
{{/unless}}
    {{#unless campaignTargeting}}
        <li>
          <label class="switch" for="sticky">
            <input type="checkbox" id="sticky" name="sticky" {{#if sticky }}checked{{/if}} >
            <div class="slider"></div>
            <span data-help="targeting-essential_ctas">Protect this CTA from Targeting</span>
          </label>
          <span class="comment">If this CTA is essential to this page, it will be shown even when a user is being targeted by another promotion.</span>
        </li>
      </ul>
    {{/unless}}
</dl></fieldset>
</div>
